import { instance2, instanceRegistrasiEMRV3 } from "App/constants"

import { makeStyles } from "@material-ui/core/styles"
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme"
import { useState, useEffect } from "react"
import moment from "moment"
import { isEmpty, isObject } from "lodash"
import {
  cantNullEmptyAndUndefined,
  dateTimePickerToValidDate,
  defaultToastError,
  isNull,
  oneMonthBeforeToday,
} from "App/utils/helpers"
import fileDownload from "js-file-download"
import { itSelfEmpty } from "utils/all"
import { endOfDay, validUTC } from "utils/dates"

export const urlGetPatientInternal = "/patient/listpatientsfilter"
export const urlGetPatientExternal = "/patient/listpatientsfilter_external"

export const urlAddPatientInternal = "/patient/addpatients"
export const urlAddPatientExternal = "/patient/addpatients_external"

export const urlUpdatePatientInternal = "/patient/updatepatients"
export const urlUpdatePatientExternal = "/patient/updatepatients_external"

export const urlGetPerusahaan = "/company/list_prm"
export const urlGetAsuransi = "/insurance/list_prm"

export const urlDeletePatientInternal = "/patient/deletepatients"
export const urlDeletePatientExternal = "/patient/deletepatients_external"

const urlSyncSatuSehat = "/patient/sinkronisasi-data-satusehat-satuan"
const urlGetMonitoring = "/patient/monitoring-ihs-pasien"
const urlJalankanRekrusif = "/patient/sinkronisasi-data-satusehat"

const urlExportPDF = "/patient/kartu-pasien"

// jika mau ganti initial value,
// harap diperhatikan validateRM() di helpers.js
export const RESET_STATE_PROFILE_REKAM_MEDIS = {
  patient_id_delete: "",
  patient_id_update: "",

  external: 0,
  fullname: "",
  first_visit_form: "",
  nik: "",
  date: moment().format("YYYY-MM-DD"),
  id_ihs: "",
  no_paspor: "",
  no_kk: "",
  nama_ibu: "",

  // Data Pasien
  place_ob: "",
  date_ob_form: "",
  blood_type: "",
  gender: "",
  ethnic: "",
  mobile_phone_number: "",
  phone_number: "",
  religion: "",
  nip: "",
  npwp: "",
  education: 0,
  occupation: 0,

  // Alamat
  address_ktp: "",
  address_now: "",
  country: 62,
  coutry_name: "Indonesia",

  province: "",
  province_name: "Pilih Provinsi",

  city: null,
  city_name: "Pilih Kota",

  district: "",
  district_name: "Pilih Kecamatan",

  sub_district: "",
  sub_district_name: "Pilih Kelurahan",

  is_same_with_ktp: 0,

  statuspernikahan: "",
  namaayah: "",

  rt: "",
  rw: "",
  postal_code: "",

  // Asuransi
  insurance_id: null,
  insurance_name: "Pilih Asuransi",

  insurance_number: "",

  company_id: null,
  company_name: "Pilih Perusahaan",

  // Penanggung :
  guarantor_connection: "",
  guarantor_name: "",

  // Media Sosial
  sc_instagram: "",
  sc_whatsapp: "",
  sc_email: "",
  sc_facebook: "",

  status: true,
}

export const RESET_STATE_FORM_FILTER = {
  idrm: "",
  namarm: "",
  nik: "",
  tanggal_lahir: "",
  alamat: "",
  status: 1,
  external: 0,
  page: 1,
  limit: 10,

  nohp: "",
  penanggung: "",

  // Asuransi
  insurance_id: null,
  insurance_name: "Pilih Asuransi",

  insurance_number: "",

  tanggal_awal: null,
  tanggal_akhir: null,
  created_name: "",
}

export const valueTypeSearch = [
  {
    label: "Semua",
    value: 0,
  },
  {
    label: "ID RM",
    value: 1,
  },
  {
    label: "Nama",
    value: 2,
  },
  {
    label: "ID Tagihan",
    value: 3,
  },
  {
    label: "No Asuransi",
    value: 4,
  },
  {
    label: "No SEP",
    value: 5,
  },
  {
    label: "Created By",
    value: 6,
  },
]

export const valueStatusPernikahan = [
  {
    value: "",
    label: "Pilih",
  },
  {
    value: "Menikah",
    label: "Menikah",
  },
  {
    value: "Belum Menikah",
    label: "Belum Menikah",
  },
  {
    value: "Cerai Mati",
    label: "Cerai Mati",
  },
  {
    value: "Cerai Hidup",
    label: "Cerai Hidup",
  },
]

export const validation = (formData) => {
  if (isEmpty(formData.jenis_layanan_id)) {
    return {
      state: false,
      message: "Jenis Layanan tidak boleh kosong",
    }
  } else if (isEmpty(formData.kelaskunjungan_id)) {
    return {
      state: false,
      message: "Kelas Kunjungan tidak boleh kosong",
    }
  } else if (isEmpty(formData.nohp)) {
    return {
      state: false,
      message: "NO HP tidak boleh kosong",
    }
  } else if (isEmpty(formData.phone_number)) {
    return {
      state: false,
      message: "NO TELEPON tidak boleh kosong",
    }
  } else if (isEmpty(formData.company_id)) {
    return {
      state: false,
      message: "Perusahaan tidak boleh kosong",
    }
  } else if (isEmpty(formData.jenis_antrian)) {
    return {
      state: false,
      message: "Jenis Antrian tidak boleh kosong",
    }
  } else {
    return {
      state: true,
    }
  }
}

export const STYLE_MASTER_GUDANG_UTAMA = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
})

export const getByFilterProfileRekamMedis = async (formFilter, page, limit) => {
  try {
    const api = await instance2.get(
      formFilter.external === 0 || formFilter.external === false
        ? urlGetPatientInternal
        : urlGetPatientExternal,
      {
        headers: {
          alamat: formFilter.alamat,
          idrm: formFilter.idrm,
          namarm: formFilter.namarm,
          nik: formFilter.nik,
          status: formFilter.status,
          tanggal_lahir: isNull(formFilter.tanggal_lahir)
            ? ""
            : dateTimePickerToValidDate(formFilter.tanggal_lahir),

          pages: page,
          limit,
          insurance_number: formFilter.insurance_number,
          insurance_id: formFilter.insurance_id ?? "",
          tanggal_awal: isNull(formFilter.tanggal_awal)
            ? ""
            : validUTC(formFilter.tanggal_awal),
          tanggal_akhir: isNull(formFilter.tanggal_akhir)
            ? ""
            : validUTC(formFilter.tanggal_akhir),
          created_name: formFilter?.created_name??"",
        },
      },
    )
    const res = api.data
    return {
      state: true,
      data: res.body,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const syncSatuSehatSatuan = async (rm) => {
  try {
    const api = await instance2.post(urlSyncSatuSehat, { id: rm })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getMonitoring = async (pages, limit) => {
  try {
    const api = await instance2.get(urlGetMonitoring, {
      params: {
        limit: limit,
        pages: pages,
      },
    })
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        data: res.body.data,
        proses: isNull(res.body.proses) ? [] : res.body.proses,
        meta: {
          count: parseInt(res.meta.count),
          pages: parseInt(res.meta.pages),
          limit: parseInt(res.meta.limit),
        },
      }
    } else {
      return {
        state: false,
        data: [],
        proses: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const jalankanRekrusif = async (id_rekonsil) => {
  try {
    const api = await instance2.post(urlJalankanRekrusif)
    const res = api.data
    if (res.status === 200) {
      return {
        state: true,
        message: res.message,
      }
    } else {
      return {
        state: false,
        message: res.message,
      }
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const exportPdf = async (datas) => {
  try {
    const response = await instance2.get(`${urlExportPDF}/${datas?.no_rm}`, {
      responseType: "blob",
    })
    return {
      state: true,
      data: response.data,
    }
  } catch (error) {
    return {
      state: false,
      data: [],
      message: "Gagal Cetak PDF Kartu Pasien",
    }
  }
}

export const usePrintPdf = () => {
  const [loading, setLoading] = useState(false)

  const handleClickPDF = async (datas) => {
    setLoading(true)
    const response = await exportPdf(datas)
    if (response.state) {
      fileDownload(
        response.data,
        `Profile Rekam Medis - ${datas.fullname} - ${datas.no_rm}.pdf`,
      )
      setLoading(false)
    } else {
      defaultToastError(response.message)
      setLoading(false)
    }
  }

  return {
    loadingPrint: loading,
    handleClickPDF: handleClickPDF,
  }
}

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id_rm",
    disablePadding: false,
    label: "ID RM",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_rm",
    disablePadding: false,
    label: "NAMA RM",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "id_ihs",
    disablePadding: false,
    label: "ID IHS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "asuransi",
    disablePadding: false,
    label: "ASURANSI",
    minWidth: "130px",
    sort: false,
  },
  {
    id: "asuransi_nomor",
    disablePadding: false,
    label: "NO. ASURANSI",
    minWidth: "130px",
    sort: false,
  },
  {
    id: "umur",
    disablePadding: false,
    label: "UMUR",
    minWidth: "200px",
    align: "center",
    sort: false,
  },
  {
    id: "tempat_lahir",
    disablePadding: false,
    label: "TEMPAT LAHIR",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "date_ob_form",
    disablePadding: false,
    label: "TANGGAL LAHIR",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "alamat",
    disablePadding: false,
    label: "ALAMAT",
    minWidth: "200px",
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "kota",
    disablePadding: false,
    label: "KOTA",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
]

export const useCity = (id) => {
  const DEFAULT_OPTION = []
  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      const api = await instance2.get("/alamat/list_kota_byprop", {
        headers: {
          ms_locpropinsi_id: id,
        },
      })

      const res = api.data
      return res.body
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (cantNullEmptyAndUndefined(id)) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: `${item.id}`,
              label: `${item.name}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useCity2 = (provinsi_code) => {
  const [state, setState] = useState([])

  const get = async () => {
    try {
      const api = await instanceRegistrasiEMRV3.get(
        "/master/lokasi/lok-ms-kota/resource-lokasi",
        {
          params: {
            provinsi_code,
          },
        },
      )

      const res = api.data
      return res.data
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isNull(provinsi_code)) {
        const res = await get()

        if (res) {
          setState(res)
        }
      }
    })()
  }, [provinsi_code]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useDistrict = (id) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      const api = await instance2.get("/alamat/list_kecamatan_bykota", {
        headers: {
          ms_lockota_id: id,
        },
      })
      const res = api.data
      return res.body
    } catch (error) {
      console.log(error?.response)
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isEmpty(id)) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: `${item.id}`,
              label: `${item.name}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useDistrict2 = (kota_code) => {
  const [state, setState] = useState([])

  const get = async () => {
    try {
      const api = await instanceRegistrasiEMRV3.get(
        "/master/lokasi/lok-ms-kecamatans/resource-lokasi",
        {
          params: {
            kota_code,
          },
        },
      )
      const res = api.data
      return res.data
    } catch (error) {
      console.log(error?.response)
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isEmpty(kota_code)) {
        const res = await get()
        if (res) {
          setState(res)
        }
      }
    })()
  }, [kota_code]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useProvinsi2 = (negara_code) => {
  const [state, setState] = useState([])
  const get = async () => {
    try {
      const api = await instanceRegistrasiEMRV3.get(
        "/master/lokasi/lok-ms-propinsis/resource-lokasi",
        {
          params: {
            negara_code,
          },
        },
      )
      const res = api.data
      return res.data
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (negara_code) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: item.value,
              label: `${item.label}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [negara_code]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useSubDistrict = (id) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)

  const get = async () => {
    try {
      const api = await instance2.get("/alamat/list_kelurahan_bykec", {
        headers: {
          ms_lockecamatan_id: id,
        },
      })
      const res = api.data
      return res.body
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isEmpty(id)) {
        const res = await get()
        if (res) {
          const data = []

          res.map((item) => {
            return data.push({
              value: `${item.id}`,
              label: `${item.name}`,
            })
          })

          setState(data)
        }
      }
    })()
  }, [id]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useSubDistrict2 = (kecamatan_code) => {
  const [state, setState] = useState([])

  const get = async () => {
    try {
      const api = await instanceRegistrasiEMRV3.get(
        "/master/lokasi/lok-ms-kelurahans/resource-lokasi",
        {
          params: {
            kecamatan_code: kecamatan_code,
          },
        },
      )
      const res = api.data
      return res.data
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isEmpty(kecamatan_code)) {
        const res = await get()
        if (res) {
          setState(res)
        }
      }
    })()
  }, [kecamatan_code]) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const deleteRekamMedisById = async (id, type) => {
  try {
    if (type === "INTERNAL") {
      await instance2.post(
        urlDeletePatientInternal,
        {},
        {
          headers: {
            idpatients: id,
          },
        },
      )
    } else {
      await instance2.post(
        urlDeletePatientExternal,
        {},
        {
          headers: {
            idpatients_external: id,
          },
        },
      )
    }

    return {
      state: true,
      message: "Data berhasil dihapus",
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const headCellsMonitoring = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    sort: false,
  },
  {
    id: "fullname",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "nik",
    disablePadding: false,
    label: "NIK",
    align: "left",
    minWidth: "100px",
    sort: false,
  },
  {
    id: "id_ihs",
    disablePadding: false,
    label: "ID IHS",
    align: "left",
    minWidth: "100px",
    sort: false,
  },
]

export const validateRM = (formData) => {
  const {
    nik,
    fullname,
    date_ob_form,
    place_ob,
    blood_type,
    namaayah,
    gender,
    ethnic,
    statuspernikahan,
    mobile_phone_number,
    religion,
    occupation,
    address_ktp,
    address_now,
    province,
    city,
    district,
    sub_district,
    company_id,
    insurance_id,
    insurance_number,
    guarantor_connection,
    guarantor_name,
  } = formData

  const formatMsg = (text) => {
    defaultToastError(`${text} tidak boleh kosong!`)
  }

  if (isEmpty(nik?.toString())) {
    formatMsg("NIK")
    return false
  }
  if (isEmpty(fullname?.toString())) {
    formatMsg("Nama")
    return false
  }
  if (isEmpty(date_ob_form?.toString())) {
    formatMsg("Tanggal Lahir")
    return false
  }
  if (isEmpty(place_ob?.toString())) {
    formatMsg("Tempat Lahir")
    return false
  }
  if (isEmpty(blood_type?.toString())) {
    formatMsg("Golongan Darah")
    return false
  }
  if (isEmpty(namaayah?.toString())) {
    formatMsg("Nama Ayah")
    return false
  }
  if (isEmpty(gender?.toString())) {
    formatMsg("Gender")
    return false
  }
  if (isEmpty(ethnic?.toString())) {
    formatMsg("Suku")
    return false
  }
  if (isEmpty(statuspernikahan?.toString())) {
    formatMsg("Status Pernikahan")
    return false
  }
  if (isEmpty(mobile_phone_number?.toString())) {
    formatMsg("Nomor HP")
    return false
  }
  if (isEmpty(religion?.toString())) {
    formatMsg("Agama")
    return false
  }
  if (isEmpty(occupation?.toString())) {
    formatMsg("Pekerjaan")
    return false
  }
  if (isEmpty(address_ktp?.toString())) {
    formatMsg("Alamat KTP")
    return false
  }
  if (isEmpty(address_now?.toString())) {
    formatMsg("Alamat Sekarang")
    return false
  }
  if (isEmpty(province?.toString())) {
    formatMsg("Provinsi")
    return false
  }
  if (isEmpty(city?.toString())) {
    formatMsg("Kota")
    return false
  }
  if (isEmpty(district?.toString())) {
    formatMsg("Kecamatan")
    return false
  }
  if (isEmpty(sub_district?.toString())) {
    formatMsg("Nomor HP")
    return false
  }
  if (isEmpty(company_id?.toString())) {
    formatMsg("Perusahaan")
    return false
  }
  if (isEmpty(insurance_id?.toString())) {
    formatMsg("Asuransi")
    return false
  }
  if (isEmpty(insurance_number?.toString())) {
    formatMsg("Nomor Asuransi")
    return false
  }
  if (isEmpty(guarantor_connection?.toString())) {
    formatMsg("Penanggung")
    return false
  }
  if (isEmpty(guarantor_name?.toString())) {
    formatMsg("Nama Penanggung")
    return false
  }
  return true
}
